import React, { ChangeEvent, useEffect, useState } from 'react';
import styles from './ImageUploader.module.scss';
import Button from '../button/Button';
import IconTrash from '../../assets/icons/trash.svg?react';
import { getMediaAbsolutePath } from '../../services/File';

type Props = {
  url: string | undefined;
  onChange: (url: string, file: File | undefined) => void;
};

function ImageUploader(props: Props) {
  const { url, onChange } = props;

  const [file, setFile] = useState<File | undefined>(undefined);
  const [localUrl, setLocalUrl] = useState('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target?.files?.[0];

    if (file) {
      setFile(file);
      const url = URL.createObjectURL(file);
      setLocalUrl(url);
      onChange(url, file);
    }
  };

  useEffect(() => {
    return () => {
      if (localUrl) {
        URL.revokeObjectURL(localUrl);
      }
    }
  }, [localUrl]);

  const handleClear = () => {
    onChange('', undefined);
    if (localUrl) {
      URL.revokeObjectURL(localUrl);
    }
  };

  const name = file?.name || (url?.split('/').pop() ?? 'No name');

  const hasContent = !!url;

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Image file</div>
      <div className={styles.content}>
        {hasContent ? <div className={styles.withContent}>
          <div className={styles.imageWrapper}>
            <div className={styles.image} style={{ backgroundImage: `url(${getMediaAbsolutePath(url)})`}}/>
          </div>
          <div className={styles.imageName}>{name}</div>
          <Button onClick={handleClear} color={'red'} size={'small'} label={'Delete'} leftIcon={<IconTrash className={styles.iconTrash}/>} outline={true}/>
        </div> : <div className={styles.empty}>
          <input className={styles.input} type={'file'} accept={'image/*'} onChange={handleChange}/>
          <div className={styles.inputText}>Choose image file</div>
        </div>}
      </div>
    </div>
  );
}

export default ImageUploader;
